import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
// import IconButton from '@mui/material/IconButton';
// import MenuIcon from '@mui/icons-material/Menu';
import Logo from '../../img/logo.png'
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state';

function Header() {

    function gotoHome() {
        window.location.href="https://www.aicarbuyer.com/";
    }

    function gotoContactPage() {
        window.location.href="https://www.aicarbuyer.com/contact";
    }

    return (
        <Box style={{ height: "64px", width: "100%", zIndex: "1", position: "fixed" }} sx={{ flexGrow: 1 }}>
            <AppBar position="static">
                <Toolbar style={{ background: "white" }}>
                    <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                        <img onClick={gotoHome} id={'calculogo'} src={Logo} alt={'logo'} />
                    </Typography>
                    {/* <Button color="inherit">Support</Button> */}
                    <PopupState variant="popover" popupId="demo-popup-menu">
                        {(popupState) => (
                            <React.Fragment>
                                <Button variant="contained" {...bindTrigger(popupState)}>
                                    Support
                                </Button>
                                <Menu {...bindMenu(popupState)}>
                                    <MenuItem onClick={popupState.close}>(888) 334-4117</MenuItem>
                                    <MenuItem onClick={gotoContactPage}>Contact Us</MenuItem>
                                </Menu>
                            </React.Fragment>
                        )}
                    </PopupState>
                </Toolbar>
            </AppBar>
        </Box>
    )
}

export default Header;